import { CreateEventrDto, IResponse, MinOrganisationDto } from "@eventr/common";
import { gateWayInstance, gateWayLongInstance } from "./axios";

const adminccPrefix = "admincc";

export const AdminAPI = {
  matchOrgV2: async (domain: string): Promise<IResponse<MinOrganisationDto[]>> => {
    const resp = await gateWayInstance.get<IResponse<MinOrganisationDto[]>>(`${adminccPrefix}/matchV2/${domain}`);
    return resp.data;
  },

  eventrExists: async (orgName: string): Promise<boolean> => {
    //encode the orgName
    const encoded = encodeURIComponent(orgName);
    const resp = await gateWayInstance.get<boolean>(`${adminccPrefix}/exists/${encoded}`);

    return resp.data;
  },

  /** `link` is the sign-in link for the welcome email; the gateway builds its own without one. */
  createEventrAndAdmin: async (body: { eventr: CreateEventrDto; link?: string }): Promise<string> => {
    const resp = await gateWayLongInstance.post<string>(`${adminccPrefix}/create`, body);

    return resp.data;
  },

  domainInList: async (body: string): Promise<boolean> => {
    const resp = await gateWayLongInstance.get<boolean>(`${adminccPrefix}/inList/${body}`);

    return resp.data;
  },
};
